<body>
    <ul>
      <div>
        <input type="file" (change)="onFileSelected($event)">
        <button class="data-save-btn" (click)="salvarNoBanco(jsonData)">Data Save lugar certo</button>
  
          <div *ngIf="showProgressBar">
            <progressbar [value]="progressValue" [max]="maxValue">{{ progressValue }} Saved lines</progressbar>
          </div>
  
        <a #downloadLink style="display: none;"></a>
        <div *ngIf="dataLoaded">
          <p>Total lines {{ jsonData.length }}</p>
          <table>
            <thead>
              <tr>
                <th>
                  <button (click)="sortBy('Process')">Transportador</button>
                </th>
                <!-- <th>
                  <button (click)="sortBy('data')">Data</button>
                </th> -->
                <th>
                  <button (click)="sortBy('janela')">Janela</button>
                </th>
                <th>
                  <button (click)="sortBy('processo')">Processo</button>
                </th>
                <th>
                  <button (click)="sortBy('idContainer')">ID Container</button>
                </th>
                <th>
                  <button (click)="sortBy('linner')">Linner</button>
                </th>
                <th>
                  <button (click)="sortBy('fatura')">Fatura</button>
                </th>
                <th>
                  <button (click)="sortBy('destino')">Destino</button>
                </th>
                <th>
                  <button (click)="sortBy('num_NF1')">Num_NF1</button>
                </th>
                <th>
                  <button (click)="sortBy('quantidadeMU')">Quantidade MU</button>
                </th>
                <th>
                  <button (click)="sortBy('terminalOrigem')">Terminal Origem</button>
                </th>
                <th>
                  <button (click)="sortBy('destinoApos')">Destino Após</button>
                </th>
                <th>
                  <button (click)="sortBy('terminalAtual')">Terminal Atual</button>
                </th>
                <th>
                    <button (click)="sortBy('itemCritico')">Item Crítico</button>
                  </th>
                  <th>
                    <button (click)="sortBy('dataFalta')">Data de Falta</button>
                  </th>
                  <th>
                    <button (click)="sortBy('invoiceRemarks')">Invoice Remarks</button>
                  </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of jsonData; let i = index">
                <td>{{ item.transportador }}</td>
                <!-- <td>{{ item.data }}</td> -->
                <td>{{ item.Janela | date : 'dd/MM/yyyy HH:mm' : '+00:00' }}</td>
                <td>{{ item.processo }}</td>
                <td>{{ item.idContainer }}</td>
                <td>{{ item.linner }}</td>
                <td>{{ item.fatura }}</td>
                <td>{{ item.destino }}</td>
                <td>{{ item.num_NF1 }}</td>
                <td>{{ item.quantidadeMU }}</td>
                <td>{{ item.terminalOrigem }}</td>
                <td>{{ item.destinoApos }}</td>
                <td>{{ item.terminalAtual }}</td>
                <td>{{ item.itemCritico }}</td>
                <td>{{ item.dataFalta | date : 'dd/MM/yyyy HH:mm' : '+00:00' }}</td>
                <td>{{ item.invoiceRemarks }}</td>
                <!-- <td >{{ item['Fornecedor 1'] != undefined ? item['Fornecedor 1'] + ' ' + (item['Janela 1'] | date : 'short' : '' : 'pt-BR') : ' ' }}</td>
                <td >{{ item['Destino 1'] != undefined ? item['Destino 1'] + ' ' + (item['JanelaDestino 1'] | date : 'short' : '' : 'pt-BR') : ' '}}</td>      -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ul>
  </body>
  <div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>
